import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = ({ items, className = '' }) => {
  const location = useLocation();

  // Configuration par défaut des breadcrumbs basée sur l'URL
  const getDefaultBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    const breadcrumbs = [{ label: 'Accueil', href: '/', icon: 'bi-house' }];

    // Mapping des routes vers des labels lisibles
    const routeLabels = {
      'individuals': 'CVthèque',
      'all-individuals': 'CVthèque',
      'partners': 'Entreprises',
      'clients': 'Entreprises',
      'positions': 'Postes',
      'offers': 'Postes',
      'reports': 'Rapports',
      'analytics': 'Rapports',
      'settings': 'Paramètres',
      'stats': 'Statistiques',
      'tags': 'Tags',
      'reminders': 'Rappels',
      'deals': 'Deals',
      'subscriptions': 'Abonnements',
      'new': 'Nouveau',
      'edit': 'Modifier',
      'scraping': 'Scraping',
      'todos': 'Todos',
      'email-templates': 'Templates'
    };

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Éviter d'ajouter les IDs comme breadcrumbs
      if (segment.length === 24 && /^[0-9a-fA-F]+$/.test(segment)) {
        return; // Skip MongoDB ObjectIds
      }

      const label = routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
      const isLast = index === pathSegments.length - 1;

      breadcrumbs.push({
        label,
        href: isLast ? null : currentPath, // Dernière page non cliquable
        isActive: isLast
      });
    });

    return breadcrumbs;
  };

  const breadcrumbItems = items || getDefaultBreadcrumbs();

  return (
    <nav className={`flex items-center space-x-1 text-sm text-gray-600 mb-3 ${className}`}>
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <i className="bi bi-chevron-right text-xs text-gray-400 mx-2"></i>
          )}
          
          {item.href ? (
            <Link 
              to={item.href} 
              className="flex text-gray-700 items-center hover:text-indigo-600 transition-colors no-underline"
            >
              {item.icon && <i className={`${item.icon} mr-1`}></i>}
              {item.label}
            </Link>
          ) : (
            <span className={`flex no-underline items-center ${item.isActive ? 'text-indigo-600 font-medium' : 'text-gray-500'}`}>
              {item.icon && <i className={`${item.icon} mr-1`}></i>}
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

// Breadcrumb personnalisé pour des contextes spécifiques
export const CustomBreadcrumb = ({ items }) => {
  return <Breadcrumb items={items} />;
};

// Breadcrumb avec contexte dynamique (pour les pages de détail)
export const DynamicBreadcrumb = ({ baseItems, currentItem }) => {
  const allItems = [...baseItems];
  
  if (currentItem) {
    allItems.push({
      label: currentItem.name || currentItem.title || currentItem.label,
      href: null,
      isActive: true
    });
  }

  return <Breadcrumb items={allItems} />;
};

export default Breadcrumb;